import {FilterBarDock} from "../filter-bar-dock";


export class SeasonPlay{
	private static selectedFilterType:string;
	private static selectedFilterLocation:string;
	

	public static init(){
		document.addEventListener('DOMContentLoaded', SeasonPlay.onDocumentLoaded, false);
	}

	private static onDocumentLoaded() {
		FilterBarDock.initOnLoaded(
			<HTMLElement>document.getElementsByClassName("monthMedium").item(0),
			SeasonPlay.filterChangedCallback);
	}

	private static filterChangedCallback(firstParam:any,secondParam:any){
		if(firstParam !== null){
			if(firstParam === 'all'){
				firstParam = undefined;
			}
			SeasonPlay.selectedFilterLocation = firstParam;
		}

		if(secondParam !== null){
			if(secondParam === 'all'){
				secondParam = undefined;
			}
			SeasonPlay.selectedFilterType = secondParam;
		}
		SeasonPlay.filter();
	}

	private static filter(){
		var entries = document.getElementsByClassName("_entry");
		for(var i = 0; i < entries.length; i++){
			if((<HTMLElement>entries.item(i)).dataset.type === SeasonPlay.selectedFilterType &&  (<string>(<HTMLElement>entries.item(i)).dataset.location).indexOf(SeasonPlay.selectedFilterLocation) !== -1){
				(<HTMLElement>entries.item(i)).style.display = "flex";
			}else if(SeasonPlay.selectedFilterType === undefined && SeasonPlay.selectedFilterLocation === undefined){
				(<HTMLElement>entries.item(i)).style.display = "flex";
			}else if((<HTMLElement>entries.item(i)).dataset.type === SeasonPlay.selectedFilterType && SeasonPlay.selectedFilterLocation === undefined){
				(<HTMLElement>entries.item(i)).style.display = "flex";
			}else if(SeasonPlay.selectedFilterType === undefined && (<string>(<HTMLElement>entries.item(i)).dataset.location).indexOf(SeasonPlay.selectedFilterLocation) !== -1){
				(<HTMLElement>entries.item(i)).style.display = "flex";
			}else{
				(<HTMLElement>entries.item(i)).style.display = "none";			}		
		}
	}
}